export default {
  warning:
    'Esta loja não está associada a uma marca. Para que o sistema funcione corretamente, a loja tem de pertencer a uma. Adicione esta loja a uma marca.',
  cta: 'Ir para marcas',
};
